import { render, staticRenderFns } from "./CommentShow.vue?vue&type=template&id=24154490&scoped=true&"
import script from "./CommentShow.vue?vue&type=script&lang=js&"
export * from "./CommentShow.vue?vue&type=script&lang=js&"
import style0 from "./CommentShow.vue?vue&type=style&index=0&id=24154490&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24154490",
  null
  
)

export default component.exports